// extracted by mini-css-extract-plugin
export default {"left-col":"left-col_k3Ate","right-col":"right-col_pG_tF","filter-bar":"filter-bar_zjoP7","coupon-list-space":"coupon-list-space_O4x4z"};